import React, { useState, useEffect, useContext } from 'react';

import ReunioesCard from "../../../reunioesInviteCard";
import UseStyle from "../../../useStyles";
import { AppContext } from '../../../../shared/context';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { getConvidados } from '../../../../../services/reuniao/ReuniaoService';

const AbaConvidadosVisualizar = (props) => {

  const { dados } = props;

  const { reuniaoUpdate } = useContext(AppContext);

  const { reuniaoUpdateListener, setReuniaoUpdate } = reuniaoUpdate;

  const [usuariosConvidados, setUsuariosConvidados] = useState([]);

  const classes = UseStyle();

  const getUsers = () => {
    if (dados && dados.id) {
      getConvidados(dados.id).then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          setUsuariosConvidados(data)
        }
      });
    }
  }

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    if (reuniaoUpdateListener === 'abaConvidados') {
      getUsers();
      setReuniaoUpdate(null);
    }
  }, [reuniaoUpdateListener]);

  return (
    <>
      <div >
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography className={classes.tituloAba}>Convidados</Typography>
            {/* <Typography style={{ color: '#5e6784', fontSize: 12, marginLeft: 12, marginTop: 2 }}>{usuariosConvidados.length} usuários convidados</Typography> */}
          </div>
          {/* <Button variant="outlined">Baixar lista de convidados</Button> */}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {usuariosConvidados.map((value, index) => (
            <div style={{ marginBottom: 24, marginRight: 24 }}>
              <ReunioesCard isVisualizar user={value} key={index} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default AbaConvidadosVisualizar;
